// extracted by mini-css-extract-plugin
module.exports = {"big_bullets":"styles_big_bullets__3_0AT","privacy":"styles_privacy__2vB3S"};